const FirebaseConfig = {
    apiKey: 'AIzaSyD6Rtf7pnnVw2tPhTpAzpvmTfv3pjEmycE',
    authDomain: 'auth-development-c480f.firebaseapp.com',
    databaseURL:
        'https://auth-development-c480f-default-rtdb.europe-west1.firebasedatabase.app',
    projectId: 'auth-development-c480f',
    storageBucket: 'auth-development-c480f.appspot.com',
    messagingSenderId: '686700033082',
    appId: '1:686700033082:web:6adcae0d176dbb451cf103',
};

export default FirebaseConfig;
